import React from 'react';
import './Projects.css';

import notifiaraVideo from '../../assets/videos/notifiara.mp4';
import chinguProject from '../../assets/images/chingu.png';
import fullChess1 from '../../assets/images/fullchess-1.png';
import objectiveoProject from '../../assets/images/objectiveo.png';
import mibossyDevProject from '../../assets/images/mibossydev.png'

import ProjectCard from './ProjectCard';

export default function Project() {
  return (
    <div className="project-container">
      <div className='project-title'>
        <h2>What I have done ?</h2>
      </div>
      <div className='projects'>
      <ProjectCard
          title="MibossyDev"
          description={
            <>
              A journal where I learn programming and explore the world of technology.
            </>
          }
          technologies="Astro, MDX"
          mediaType="image"
          mediaSrc={mibossyDevProject}
          mediaAlt="MibossyDev App"
          links={[
            { label: 'Live', href: 'https://mibossydev.netlify.app/' }
          ]}
        />
      <ProjectCard
          title="Objectiveo"
          description={
            <>
              Generate clear goals and their associated routines using different models.
            </>
          }
          technologies="Next.js, groq API"
          mediaType="image"
          mediaSrc={objectiveoProject}
          mediaAlt="Objectiveo App"
          links={[
            { label: 'Live', href: 'https://objectiveo.vercel.app/' }
          ]}
        />
        <ProjectCard
          title="Chingu-Hotel-BT-30"
          description={
            <>
              A web application in progress that I developed with my teams during my internship at <span>Chingu</span>.
            </>
          }
          technologies="MERN stack (MongoDB, ExpressJS, ReactJS, NodeJS)"
          mediaType="image"
          mediaSrc={chinguProject}
          mediaAlt="Chingu booking room"
          links={[
            { label: 'Source code', href: 'https://github.com/chingu-voyages/v42-bears-team-30.git' },
            { label: 'Live', href: 'https://chingu-bt-30.onrender.com/' }
          ]}
        />
        <ProjectCard
          title="NOTIFIARA"
          description={
            <>
              In general, it helps you to remember when you have to maintain your vehicle, what maintenance tasks you should do, and see statistics of your vehicle activity. Improvements are still to be made <span role="img" aria-label="emoji">🙂</span>.
            </>
          }
          technologies="HTML5, CSS3, Bootstrap 5, Javascript, Axios, ChartJS, openstreetmap, leaflet, Symfony 6, MySQL"
          mediaType="video"
          mediaSrc={notifiaraVideo}
        />
        <ProjectCard
          title="Fullchess"
          description="An alpha version of a human versus human 2D chess game."
          technologies="JAVA, JavaSwing"
          mediaType="image"
          mediaSrc={fullChess1}
          mediaAlt="Fullchess"
          links={[
            { label: 'Source code', href: 'https://github.com/Fullfifax/Fullchess.git' }
          ]}
          reverse
        />
      </div>
    </div>
  );
}